var map = {
	"./AddColorButton": 44,
	"./AddColorButton.jsx": 44,
	"./AddPrintButton": 45,
	"./AddPrintButton.jsx": 45,
	"./AddProductButton": 80,
	"./AddProductButton.jsx": 80,
	"./BalanceColor": 69,
	"./BalanceColor/": 69,
	"./BalanceColor/BalanceColor": 81,
	"./BalanceColor/BalanceColor.jsx": 81,
	"./BalanceColor/index": 69,
	"./BalanceColor/index.js": 69,
	"./BalanceSlider": 70,
	"./BalanceSlider/": 70,
	"./BalanceSlider/BalanceSlider": 82,
	"./BalanceSlider/BalanceSlider.jsx": 82,
	"./BalanceSlider/BarChart": 29,
	"./BalanceSlider/BarChart.jsx": 29,
	"./BalanceSlider/Pager": 83,
	"./BalanceSlider/Pager.jsx": 83,
	"./BalanceSlider/Pie": 34,
	"./BalanceSlider/Pie.jsx": 34,
	"./BalanceSlider/Slide": 84,
	"./BalanceSlider/Slide.jsx": 84,
	"./BalanceSlider/SlidePeople": 85,
	"./BalanceSlider/SlidePeople.jsx": 85,
	"./BalanceSlider/SlidePlanet": 86,
	"./BalanceSlider/SlidePlanet.jsx": 86,
	"./BalanceSlider/SlideProduct": 88,
	"./BalanceSlider/SlideProduct.jsx": 88,
	"./BalanceSlider/SlideProsperity": 87,
	"./BalanceSlider/SlideProsperity.jsx": 87,
	"./BalanceSlider/index": 70,
	"./BalanceSlider/index.js": 70,
	"./Burger": 41,
	"./Burger/": 41,
	"./Burger/Burger": 71,
	"./Burger/Burger.jsx": 71,
	"./Burger/Burger.styled": 89,
	"./Burger/Burger.styled.js": 89,
	"./Burger/index": 41,
	"./Burger/index.js": 41,
	"./BurgerMenu": 197,
	"./BurgerMenu.jsx": 197,
	"./ChatForm": 176,
	"./ChatForm.jsx": 176,
	"./ChatForm/": 177,
	"./ChatForm/Body": 91,
	"./ChatForm/Body.jsx": 91,
	"./ChatForm/ChatForm": 47,
	"./ChatForm/ChatForm.jsx": 47,
	"./ChatForm/Context": 55,
	"./ChatForm/Context.jsx": 55,
	"./ChatForm/FormModal": 92,
	"./ChatForm/FormModal.jsx": 92,
	"./ChatForm/IconBadge": 93,
	"./ChatForm/IconBadge.jsx": 93,
	"./ChatForm/index": 177,
	"./ChatForm/index.js": 177,
	"./ColorTile": 48,
	"./ColorTile.jsx": 48,
	"./ColorTileWrapper": 36,
	"./ColorTileWrapper.jsx": 36,
	"./ColorsGallery": 49,
	"./ColorsGallery.jsx": 49,
	"./ColorsGallery/ColorDetails": 95,
	"./ColorsGallery/ColorDetails.jsx": 95,
	"./ColorsGallery/ColorsGallery": 94,
	"./ColorsGallery/ColorsGallery.jsx": 94,
	"./ComposedImage": 38,
	"./ComposedImage.jsx": 38,
	"./Icon": 6,
	"./Icon.jsx": 6,
	"./Instafeed": 73,
	"./Instafeed/": 73,
	"./Instafeed/Instafeed": 96,
	"./Instafeed/Instafeed.jsx": 96,
	"./Instafeed/InstafeedItem": 97,
	"./Instafeed/InstafeedItem.jsx": 97,
	"./Instafeed/index": 73,
	"./Instafeed/index.js": 73,
	"./Menu": 42,
	"./Menu/": 42,
	"./Menu/Menu": 72,
	"./Menu/Menu.jsx": 72,
	"./Menu/Menu.styled": 46,
	"./Menu/Menu.styled.js": 46,
	"./Menu/MenuOld": 188,
	"./Menu/MenuOld.jsx": 188,
	"./Menu/index": 42,
	"./Menu/index.js": 42,
	"./PrintsGallery": 43,
	"./PrintsGallery/": 43,
	"./PrintsGallery/PrintDetails": 99,
	"./PrintsGallery/PrintDetails.jsx": 99,
	"./PrintsGallery/PrintsGallery": 98,
	"./PrintsGallery/PrintsGallery.jsx": 98,
	"./PrintsGallery/index": 43,
	"./PrintsGallery/index.js": 43,
	"./PrintsPage": 74,
	"./PrintsPage/": 74,
	"./PrintsPage/Context": 28,
	"./PrintsPage/Context.jsx": 28,
	"./PrintsPage/Header": 102,
	"./PrintsPage/Header.jsx": 102,
	"./PrintsPage/HeaderFilters": 103,
	"./PrintsPage/HeaderFilters.jsx": 103,
	"./PrintsPage/Layout": 101,
	"./PrintsPage/Layout.jsx": 101,
	"./PrintsPage/PrintTile": 107,
	"./PrintsPage/PrintTile.jsx": 107,
	"./PrintsPage/PrintsGallery": 104,
	"./PrintsPage/PrintsGallery.jsx": 104,
	"./PrintsPage/PrintsPage": 100,
	"./PrintsPage/PrintsPage.jsx": 100,
	"./PrintsPage/PrintsSlide": 106,
	"./PrintsPage/PrintsSlide.jsx": 106,
	"./PrintsPage/PrintsSlider": 105,
	"./PrintsPage/PrintsSlider.jsx": 105,
	"./PrintsPage/index": 74,
	"./PrintsPage/index.js": 74,
	"./ProductPage": 75,
	"./ProductPage/": 75,
	"./ProductPage/Body": 110,
	"./ProductPage/Body.jsx": 110,
	"./ProductPage/ColorsView": 117,
	"./ProductPage/ColorsView.jsx": 117,
	"./ProductPage/Context": 23,
	"./ProductPage/Context.jsx": 23,
	"./ProductPage/FallbackImage": 116,
	"./ProductPage/FallbackImage.jsx": 116,
	"./ProductPage/Header": 109,
	"./ProductPage/Header.jsx": 109,
	"./ProductPage/ProductBadge": 113,
	"./ProductPage/ProductBadge.jsx": 113,
	"./ProductPage/ProductDatatable": 112,
	"./ProductPage/ProductDatatable.jsx": 112,
	"./ProductPage/ProductDetail": 111,
	"./ProductPage/ProductDetail.jsx": 111,
	"./ProductPage/ProductImage": 115,
	"./ProductPage/ProductImage.jsx": 115,
	"./ProductPage/ProductPage": 108,
	"./ProductPage/ProductPage.jsx": 108,
	"./ProductPage/ProductTestSpecs": 114,
	"./ProductPage/ProductTestSpecs.jsx": 114,
	"./ProductPage/index": 75,
	"./ProductPage/index.js": 75,
	"./ProductsConfiguratorPage": 76,
	"./ProductsConfiguratorPage/": 76,
	"./ProductsConfiguratorPage/ArtemidaHeader": 120,
	"./ProductsConfiguratorPage/ArtemidaHeader.jsx": 120,
	"./ProductsConfiguratorPage/ArticlesGrid": 137,
	"./ProductsConfiguratorPage/ArticlesGrid.jsx": 137,
	"./ProductsConfiguratorPage/BackButton": 18,
	"./ProductsConfiguratorPage/BackButton.jsx": 18,
	"./ProductsConfiguratorPage/Body": 136,
	"./ProductsConfiguratorPage/Body.jsx": 136,
	"./ProductsConfiguratorPage/CategoriesFilters": 193,
	"./ProductsConfiguratorPage/CategoriesFilters.jsx": 193,
	"./ProductsConfiguratorPage/ColorTile": 143,
	"./ProductsConfiguratorPage/ColorTile.jsx": 143,
	"./ProductsConfiguratorPage/ColorsFilters": 194,
	"./ProductsConfiguratorPage/ColorsFilters.jsx": 194,
	"./ProductsConfiguratorPage/ColorsView": 142,
	"./ProductsConfiguratorPage/ColorsView.jsx": 142,
	"./ProductsConfiguratorPage/Context": 13,
	"./ProductsConfiguratorPage/Context.jsx": 13,
	"./ProductsConfiguratorPage/DownloadModal": 65,
	"./ProductsConfiguratorPage/DownloadModal.jsx": 65,
	"./ProductsConfiguratorPage/DownloadModal/": 178,
	"./ProductsConfiguratorPage/DownloadModal/Body": 145,
	"./ProductsConfiguratorPage/DownloadModal/Body.jsx": 145,
	"./ProductsConfiguratorPage/DownloadModal/Context": 56,
	"./ProductsConfiguratorPage/DownloadModal/Context.jsx": 56,
	"./ProductsConfiguratorPage/DownloadModal/DownloadModal": 52,
	"./ProductsConfiguratorPage/DownloadModal/DownloadModal.jsx": 52,
	"./ProductsConfiguratorPage/DownloadModal/FormModal": 146,
	"./ProductsConfiguratorPage/DownloadModal/FormModal.jsx": 146,
	"./ProductsConfiguratorPage/DownloadModal/IconBadge": 147,
	"./ProductsConfiguratorPage/DownloadModal/IconBadge.jsx": 147,
	"./ProductsConfiguratorPage/DownloadModal/index": 178,
	"./ProductsConfiguratorPage/DownloadModal/index.js": 178,
	"./ProductsConfiguratorPage/FilterButton": 51,
	"./ProductsConfiguratorPage/FilterButton.jsx": 51,
	"./ProductsConfiguratorPage/FilterItem": 21,
	"./ProductsConfiguratorPage/FilterItem.jsx": 21,
	"./ProductsConfiguratorPage/FiltersCloud": 123,
	"./ProductsConfiguratorPage/FiltersCloud.jsx": 123,
	"./ProductsConfiguratorPage/FiltersMainMenu": 122,
	"./ProductsConfiguratorPage/FiltersMainMenu.jsx": 122,
	"./ProductsConfiguratorPage/FiltersSecondaryMenu": 124,
	"./ProductsConfiguratorPage/FiltersSecondaryMenu.jsx": 124,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuContent": 125,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuContent.jsx": 125,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterAnilina": 133,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterAnilina.jsx": 133,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterAppearance": 134,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterAppearance.jsx": 134,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterColor": 127,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterColor.jsx": 127,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterFlower": 131,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterFlower.jsx": 131,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterPrice": 128,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterPrice.jsx": 128,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterSector": 130,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterSector.jsx": 130,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterTexture": 132,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterTexture.jsx": 132,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterThickness": 129,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFilterThickness.jsx": 129,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFiltersSelection": 126,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFiltersSelection.jsx": 126,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFooter": 135,
	"./ProductsConfiguratorPage/FiltersSecondaryMenuFooter.jsx": 135,
	"./ProductsConfiguratorPage/Header": 119,
	"./ProductsConfiguratorPage/Header.jsx": 119,
	"./ProductsConfiguratorPage/HeaderFilters": 50,
	"./ProductsConfiguratorPage/HeaderFilters.jsx": 50,
	"./ProductsConfiguratorPage/Layout": 169,
	"./ProductsConfiguratorPage/Layout.jsx": 169,
	"./ProductsConfiguratorPage/LoadMoreSpinner": 144,
	"./ProductsConfiguratorPage/LoadMoreSpinner.jsx": 144,
	"./ProductsConfiguratorPage/PaginationArrow": 66,
	"./ProductsConfiguratorPage/PaginationArrow.jsx": 66,
	"./ProductsConfiguratorPage/ProductTile": 140,
	"./ProductsConfiguratorPage/ProductTile.jsx": 140,
	"./ProductsConfiguratorPage/ProductTileSpecs": 141,
	"./ProductsConfiguratorPage/ProductTileSpecs.jsx": 141,
	"./ProductsConfiguratorPage/ProductTileWrapper": 139,
	"./ProductsConfiguratorPage/ProductTileWrapper.jsx": 139,
	"./ProductsConfiguratorPage/ProductsConfiguratorFilters": 121,
	"./ProductsConfiguratorPage/ProductsConfiguratorFilters.jsx": 121,
	"./ProductsConfiguratorPage/ProductsConfiguratorPage": 118,
	"./ProductsConfiguratorPage/ProductsConfiguratorPage.jsx": 118,
	"./ProductsConfiguratorPage/ProductsView": 138,
	"./ProductsConfiguratorPage/ProductsView.jsx": 138,
	"./ProductsConfiguratorPage/index": 76,
	"./ProductsConfiguratorPage/index.js": 76,
	"./ProductsConfiguratorPage/utils": 64,
	"./ProductsConfiguratorPage/utils.js": 64,
	"./ProductsPage": 77,
	"./ProductsPage/": 77,
	"./ProductsPage/ArtemidaHeader": 151,
	"./ProductsPage/ArtemidaHeader.jsx": 151,
	"./ProductsPage/ArticlesGrid": 156,
	"./ProductsPage/ArticlesGrid.jsx": 156,
	"./ProductsPage/Body": 155,
	"./ProductsPage/Body.jsx": 155,
	"./ProductsPage/CategoriesFilters": 153,
	"./ProductsPage/CategoriesFilters.jsx": 153,
	"./ProductsPage/ColorsFilters": 154,
	"./ProductsPage/ColorsFilters.jsx": 154,
	"./ProductsPage/ColorsView": 161,
	"./ProductsPage/ColorsView.jsx": 161,
	"./ProductsPage/Context": 14,
	"./ProductsPage/Context.jsx": 14,
	"./ProductsPage/Header": 150,
	"./ProductsPage/Header.jsx": 150,
	"./ProductsPage/HeaderFilters": 53,
	"./ProductsPage/HeaderFilters.jsx": 53,
	"./ProductsPage/Layout": 149,
	"./ProductsPage/Layout.jsx": 149,
	"./ProductsPage/LoadMoreSpinner": 162,
	"./ProductsPage/LoadMoreSpinner.jsx": 162,
	"./ProductsPage/PaginationArrow": 39,
	"./ProductsPage/PaginationArrow.jsx": 39,
	"./ProductsPage/ProductTile": 159,
	"./ProductsPage/ProductTile.jsx": 159,
	"./ProductsPage/ProductTileSpecs": 160,
	"./ProductsPage/ProductTileSpecs.jsx": 160,
	"./ProductsPage/ProductTileWrapper": 158,
	"./ProductsPage/ProductTileWrapper.jsx": 158,
	"./ProductsPage/ProductsFilters": 152,
	"./ProductsPage/ProductsFilters.jsx": 152,
	"./ProductsPage/ProductsPage": 148,
	"./ProductsPage/ProductsPage.jsx": 148,
	"./ProductsPage/ProductsView": 157,
	"./ProductsPage/ProductsView.jsx": 157,
	"./ProductsPage/SliderItem": 54,
	"./ProductsPage/SliderItem.jsx": 54,
	"./ProductsPage/index": 77,
	"./ProductsPage/index.js": 77,
	"./Ruler": 37,
	"./Ruler.jsx": 37,
	"./SamplesCart": 195,
	"./SamplesCart.jsx": 195,
	"./SamplesCart/Badge": 164,
	"./SamplesCart/Badge.jsx": 164,
	"./SamplesCart/SamplesCart": 163,
	"./SamplesCart/SamplesCart.jsx": 163,
	"./Slider": 78,
	"./Slider/": 78,
	"./Slider/Slide": 166,
	"./Slider/Slide.jsx": 166,
	"./Slider/SlideCaption": 167,
	"./Slider/SlideCaption.jsx": 167,
	"./Slider/Slider": 165,
	"./Slider/Slider.jsx": 165,
	"./Slider/index": 78,
	"./Slider/index.js": 78,
	"./TrendColor": 79,
	"./TrendColor/": 79,
	"./TrendColor/TrendColor": 168,
	"./TrendColor/TrendColor.jsx": 168,
	"./TrendColor/index": 79,
	"./TrendColor/index.js": 79,
	"./theme": 90,
	"./theme.js": 90,
	"./utils": 11,
	"./utils.js": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;